import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe para truncar texto com limite de caracteres
 * Adiciona '...' ao final quando o texto excede o limite
 * 
 * Uso: {{ texto | truncate:30 }}
 * Exemplo: "Texto muito longo aqui" | truncate:10 -> "Texto muit..."
 */
@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {
  /**
   * Transforma o texto truncando no limite especificado
   * @param value Texto a ser truncado
   * @param limit Número máximo de caracteres (padrão: 50)
   * @param completeWords Se true, trunca apenas em espaços (padrão: false)
   * @param ellipsis Caracteres a adicionar no final (padrão: '...')
   * @returns Texto truncado
   */
  transform(
    value: string, 
    limit: number = 50, 
    completeWords: boolean = false, 
    ellipsis: string = '...'
  ): string {
    if (!value) {
      return '';
    }

    if (value.length <= limit) {
      return value;
    }

    if (completeWords) {
      // Trunca apenas em espaços (palavras completas)
      const truncated = value.substring(0, limit);
      const lastSpace = truncated.lastIndexOf(' ');
      
      if (lastSpace > 0) {
        return truncated.substring(0, lastSpace) + ellipsis;
      }
    }

    // Trunca no limite exato
    return value.substring(0, limit) + ellipsis;
  }
}

